import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPurchase from './reducers/purchase.reducer';
import { EffectsModule } from '@ngrx/effects';
import { PurchaseEffects } from './effects/purchase.effects';
import * as fromPurchaseFilter from './reducers/purchase-filter.reducer';
import { PurchaseFilterEffects } from './effects/purchase-filter.effects';
import * as fromPackage from './reducers/package.reducer';
import { PackageEffects } from './effects/package.effects';
import * as fromOrder from './reducers/order.reducer';
import { OrderEffects } from './effects/order.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('purchase', fromPurchase.reducer),
    EffectsModule.forFeature([PurchaseEffects, PurchaseFilterEffects, PackageEffects, OrderEffects]),
    StoreModule.forFeature('purchaseFilter', fromPurchaseFilter.reducer),
    StoreModule.forFeature('package', fromPackage.reducer),
    StoreModule.forFeature('order', fromOrder.reducer),
    StoreModule.forFeature('packageOtp', fromPurchase.purchaseOtpreducer),
    StoreModule.forFeature('agreementApprovalUrl', fromPurchase.PayPalAgreementApprovalUrlReducer)
  ]
})
export class PurchaseModule { }
